import React, { useEffect, useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';

const GoogleLoginButton = ({ onSuccess, onError }) => {
  const googleButtonDiv = useRef(null);

  // This function will be called by Google's library after the user signs in
  const handleCredentialResponse = (response) => {
    console.log('✅ Credential response received:', response);
    if (response.credential) {
      onSuccess(response.credential);
    } else {
      console.error('❌ No credential received from Google.');
      onError('No credential received from Google.');
    }
  };

  useEffect(() => {
    // 1. Check if the Google script is already loaded
    if (window.google) {
      console.log('🔧 Google script already available.');
      initializeAndRenderButton();
      return;
    }

    // 2. If not, create and load the script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      console.log('✅ Google Identity Services script loaded.');
      initializeAndRenderButton();
    };
    script.onerror = () => {
      console.error('❌ Failed to load Google Identity Services script.');
      onError('Failed to load Google script.');
    };
    document.body.appendChild(script);

    // 3. Cleanup function to remove the script
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures this runs only once on mount

  const initializeAndRenderButton = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!clientId) {
      console.error('❌ Google Client ID is not defined.');
      onError('Google Client ID is missing.');
      return;
    }

    if (!window.google || !window.google.accounts || !window.google.accounts.id) {
        console.error('❌ Google library is not initialized correctly.');
        onError('Google library failed to initialize.');
        return;
    }

    // Initialize the client
    try {
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse, // The function to handle the JWT token
      });
      console.log('✅ Google Sign-In initialized.');

      // Render the button
      // The button will be rendered in the div pointed to by the ref
      if (googleButtonDiv.current) {
        window.google.accounts.id.renderButton(
          googleButtonDiv.current,
          {
            theme: 'outline',
            size: 'large',
            type: 'standard',
            shape: 'rectangular',
            text: 'continue_with',
            logo_alignment: 'left',
            width: '280' // Set a fixed width or make it responsive
          }
        );
        console.log('✅ Google button rendered.');
      }

      // Optional: Also display the One Tap prompt for returning users
      window.google.accounts.id.prompt();

    } catch (error) {
      console.error('❌ Error initializing or rendering Google button:', error);
      onError(error.message);
    }
  };


  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
      {/* This div is the container for the official Google button.
        It will be populated by the Google script.
        We hide our custom button logic and use this instead.
      */}
      <div
        ref={googleButtonDiv}
        style={{ minHeight: '44px', display: 'flex', justifyContent: 'center' }}
      ></div>
      
    </Box>
  );
};

export default GoogleLoginButton;